import { ActionTypes } from "../Types/types"

export const saveWebsiteCannedToRedux = (data) => async (dispatch) => {
    try {
        dispatch({
            type: ActionTypes.CANNED_MESSAGES,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: ActionTypes.CANNED_MESSAGES,
            payload: [],
        });
    }
};

export const savePersonalCanned = (data) => async (dispatch) => {
    try {
        dispatch({
            type: ActionTypes.PERSONAL_CANNED_MESSAGES,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: ActionTypes.PERSONAL_CANNED_MESSAGES,
            payload: [],
        });
    }
};

export const persistResources = (data: any) => ({
    type: ActionTypes.RESOURCES,
    payload: data,
});


export const persistAllCannedMessage = (data: any) => ({
    type: ActionTypes.ALL_CANNED_MESSAGES,
    payload: data,
});
